import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-21",
  "use": "icon-button_icon-21-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-21\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M3 6c0 2.761 4.03 5 9 5s9-2.239 9-5M21 6c0-2.761-4.03-5-9-5S3 3.239 3 6M3 13c0 2.21 4.03 4 9 4s9-1.79 9-4M3 19c0 2.21 4.03 4 9 4s9-1.79 9-4\" /><path stroke-linecap=\"round\" d=\"M21 19V6M3 19V6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol